import { render } from "./RestaurantConfigurations.vue?vue&type=template&id=58aeec3a&ts=true"
import script from "./RestaurantConfigurations.vue?vue&type=script&lang=ts"
export * from "./RestaurantConfigurations.vue?vue&type=script&lang=ts"

import "./RestaurantConfigurations.vue?vue&type=style&index=0&id=58aeec3a&lang=css"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__